/**
 * Skills related api calls are kept here
 */

import axios, { baseRequestConfig } from './base';

export function getSkillList() {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      request1: {
        request_type: 'FUNCTION',
        function_name: 'skill_list',
      },
    },
  });
}

export function searchSkills(userToken, input) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'skill_search',
        values: {
          skill_name: input,
        },
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/skills.js